module.exports = __webpack_public_path__ + "images/emoji/no_good.adc8a98b9130999ae140.png";